import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';

const ROUTES = {
  dashboard: '/',
  seedEmbedded: '/seed',
  seedApply: '/seed-apply',
  notVerified: '/not-verified',
  oops: '/oops',
  404: '/404'
};

const SUBDOMAINS = {
  lending: 'lending',
  dashboard: 'dashboard',
  vueSite: 'app',
  seed: 'seed',
  admin: 'admin',
  components: 'components'
};

const getRedirectURLForRedirect = (subdomain) => {
  if (import.meta.env.VITE_ENV === 'production') {
    return `https://${subdomain}.viva-finance.com`;
  }
  if (import.meta.env.VITE_ENV === 'staging') {
    return `https://dev.${subdomain}.viva-finance.com`;
  }
  if (import.meta.env.VITE_ENV === 'hydrogen') {
    return `https://hydrogen.${subdomain}.viva-finance.com`;
  }

  if (import.meta.env.VITE_ENV === 'development') {
    if (subdomain === SUBDOMAINS.dashboard) return `http://localhost:3000`;
    if (subdomain === SUBDOMAINS.lending) return `http://localhost:3001`;
    if (subdomain === SUBDOMAINS.vueSite) return `http://localhost:8080`;
    if (subdomain === SUBDOMAINS.seed) return `http://localhost:3002`;
    if (subdomain === SUBDOMAINS.admin) return `http://localhost:2998`;
  }

  return `error`;
};

// eslint-disable-next-line react/prop-types
function Redirect({ redirect }) {
  useEffect(() => {
    if (redirect) window.location.assign(redirect);
  }, [redirect]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route
        path={ROUTES.dashboard}
        element={<Redirect redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}/`} />}
      />

      <Route
        path={ROUTES.seedApply}
        element={
          <Redirect
            redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES.seedApply}`}
          />
        }
      />

      <Route
        path={ROUTES.seedEmbedded}
        element={
          <Redirect
            redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES.seedEmbedded}`}
          />
        }
      />

      <Route
        path={ROUTES.notVerified}
        element={
          <Redirect
            redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES.notVerified}`}
          />
        }
      />

      <Route
        path={ROUTES.oops}
        element={
          <Redirect redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES.oops}`} />
        }
      />

      <Route
        path="*"
        element={
          <Redirect
            redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES['404']}`}
          />
        }
      />
      <Route
        path={ROUTES['404']}
        element={
          <Redirect
            redirect={`${getRedirectURLForRedirect(SUBDOMAINS.dashboard)}${ROUTES['404']}`}
          />
        }
      />
    </Routes>
  </BrowserRouter>
);
